<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="organisme?.classificationOrganisme"
	[label]="step1.getclassificationorganisme" [type]="'select'"
[typeSelect]="optionsSelectType" [optionsWithCode]="optionsSelect"
	[rule]="'pattern_26'" [name]="getUid() + '_SepAtt_classificationOrganisme'">
</app-form-input>

<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="organisme?.acheteurPublic"
	[label]="step1.getacheteurpublic" [type]="'text'" [rule]="rule + 'pattern_31|minSize_5|maxSize_400'"
	[errorMessage]="{'required' : 'ctr_626', 'minLength' : 'ctr_97'}" [name]="getUid() + '_SepAtt_acheteurPublic'">
</app-form-input>

<app-type-adresse [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled" [adr]="organisme?.adr">
</app-type-adresse>

<app-type-pers [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
	[personnePhysique]="organisme?.correspondantPRM"></app-type-pers>

<app-type-coord [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled" [coord]="organisme?.coord">
</app-type-coord>

<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="organisme?.urlProfilAcheteur"
	[label]="step1.geturlprofilacheteur" [type]="'text'" [rule]="'pattern_28|maxSize_200'"
	[errorMessage]="{'pattern' : 'ctr_7'}" [name]="getUid() + '_SepAtt_urlProfilAcheteur'">
</app-form-input>